import React, { useContext, useState } from 'react';

import { Link } from "react-router-dom";

import { SettingsContext } from '../contexts/index.jsx';
import { ChangePasswordForm } from "../forms";
import { Verification} from "../components"
import { useMerchantStripe } from '../merchants';

const ResetPassword = ({ user, authentication }) => {
  const settings = useContext(SettingsContext);
  const { goToStripeManagementPage } = useMerchantStripe();
  const [verifUser, setVerifUser] = useState();
  const [token, setToken] = useState();

  const onCodeVerified = ({ user, token }) => {
    if (!settings.isRetailCircle) {
      authentication.login(user, token, false)
    }

    setVerifUser(user)
    setToken(token);
  }

  const link = settings.isRetailCircle ? (
    <a onClick={() => goToStripeManagementPage(user || verifUser, token, false, true)} style={{ cursor: 'pointer' }}>dashboard</a>
  ) : (
    <Link to={`/?${settings.iframeQueryParams}`}>dashboard</Link>
  )

  return (
    <Verification
      onSubmit={onCodeVerified}
    >
      <main id='reset-password'>
        <div className="container">
          <ChangePasswordForm
            user={user || verifUser}
            successMessage={<>Go to your {link}.</>}
            token={token}
          />
        </div>
      </main>
    </Verification>
  )
}

export default ResetPassword
